"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const opportunity_1 = require("./opportunity");
const enums_1 = require("../../../@shared-types/opportunites/enums");
let OpportunintyNoteFormComponent = class OpportunintyNoteFormComponent {
    constructor(opportunityModel) {
        this.opportunityModel = opportunityModel;
        this.data = { title: 'Notiz hinzufügen' };
        this.updateData = {
            message: '',
        };
        this.addNote = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.opportunity.id)
                return;
            const data = {
                message: this.updateData.message,
            };
            yield this.opportunityModel.postInfo({
                data,
                opportunityId: this.opportunity.id,
                type: enums_1.EOpportunityInfoType.NOTE,
            });
            this.exit(true);
        });
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], OpportunintyNoteFormComponent.prototype, "opportunity", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Function)
], OpportunintyNoteFormComponent.prototype, "exit", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_a = typeof enums_1.EOpportunityState !== "undefined" && enums_1.EOpportunityState) === "function" ? _a : Object)
], OpportunintyNoteFormComponent.prototype, "state", void 0);
OpportunintyNoteFormComponent = __decorate([
    (0, core_1.Component)({
        selector: 'opportunity-note-form',
        template: /* html */ `
  <side-sheet [title]="data.title" [exit]="exit">
    <form class="default-form" (ngSubmit)="addNote()" id="stateForm">
      <div class="row">
        <div class="input-wrap col-md-12">
          <textarea name="stateReason"
            [(ngModel)]="updateData.message"
            placeholder="Notiz" required rows="3"></textarea>
          <label for="stateReason">Notiz</label>
        </div>
      </div>
    </form>

    <button
      actions
      form="stateForm"
      type="submit"
      class="btn-lvl1"
      ng-class="{'btn-sending': survey.sending}"
      ng-disabled="survey.sending"
    >Notiz speichern</button>
  </side-sheet>
  `,
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof opportunity_1.OpportunityModel !== "undefined" && opportunity_1.OpportunityModel) === "function" ? _b : Object])
], OpportunintyNoteFormComponent);
exports.default = OpportunintyNoteFormComponent;
